module.exports = __webpack_public_path__ + "img/owl.66d6e00a.png";